import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';


import { getMemberinfo, numFormat } from "../../utils/utils";


import * as APIS from "../../utils/service";
import Select from '../../component/Select';
import Checkbox from '../../component/Checkbox';

export default function CompanyCalc({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [memberinfos, setmemberinfos] = useState('');
    const [lists, setlists] = useState([]);

    //----
    const [selectMonth, setselectMonth] = useState("");
    const [viewIds, setviewIds] = useState([]);


    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        listopen();
    }, []);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {}
        APIS.postData('/v1/compony/news', sender).then(({ data }) => {
            if (data) {
                setlists(data);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    return (
        <>
            <Layout header={false} actives={''}>
                <div className='mypagearea'>
                    <div >
                        <MypageleftArea pages={1} />
                    </div>
                    <div className='padding32'>
                        <div className='pagetitle fontsize20 bolds'>사무소관리</div>
                        <div className='pagetabs margint20'>
                            <button onClick={() => { navigate('/CompanyNotice') }}>사내공지</button>
                            <button onClick={() => { navigate('/CompanyInfo') }}>사무소정보</button>
                            <button className='active' onClick={() => { navigate('/CompanyCalc') }}>정산</button>
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <Select
                                setValues={setselectMonth}
                                values={selectMonth}
                                selectData={[
                                    { labels: '2025년 3월', values: '202403' },
                                    { labels: '2025년 2월', values: '202402' },
                                ]}
                            />

                            <div>
                                <div className="productlist_th" style={{ fontSize: 10, marginTop: 10 }}>
                                    <div style={{ width: 40 }}>이름</div>
                                    <div style={{ width: 40 }}>직급</div>
                                    <div style={{ width: 60 }}>유형</div>
                                    <div style={{ width: 40 }}>비율</div>
                                    <div style={{ width: 60 }}>근로형태</div>
                                    <div style={{ width: 60 }}>기본급</div>
                                    <div style={{ width: 70 }}>계약수수료</div>
                                    <div style={{ width: 70 }}>실입금 수수료</div>
                                    <div style={{ width: 70 }}>세전 정산 금액</div>
                                    <div style={{ width: 60 }}>원천세</div>
                                    <div style={{ width: 70 }}>최종 정산 금액</div>
                                    <div style={{ width: 70 }}>사무소 수익</div>
                                </div>
                                {Array(3).fill({})?.map((x, i) => {
                                    return (<>
                                        <div
                                            key={i}
                                            className="productlist_td"
                                            style={{ cursor: 'pointer', fontSize: 10 }}
                                            onClick={() => {
                                                setviewIds(v => {
                                                    if (v.includes(i)) {
                                                        v.splice(v.indexOf(i), 1)
                                                    } else {
                                                        v.push(i)
                                                    }

                                                    return [...v]
                                                })
                                            }}
                                        >
                                            <div style={{ width: 40 }}>홍길동</div>
                                            <div style={{ width: 40 }}>팀장</div>
                                            <div style={{ width: 60 }}>공인중개사</div>
                                            <div style={{ width: 40 }}>100%</div>
                                            <div style={{ width: 60 }}>프리랜서</div>
                                            <div style={{ width: 60 }}>1,500,000원</div>
                                            <div style={{ width: 70 }}>10,000,000원</div>
                                            <div style={{ width: 70 }}>10,000,000원</div>
                                            <div style={{ width: 70 }}>10,000,000원</div>
                                            <div style={{ width: 60 }}>1,000,000원</div>
                                            <div style={{ width: 70 }}>10,000,000원</div>
                                            <div style={{ width: 70 }}>10,000,000원</div>
                                        </div>
                                        {viewIds.includes(i) && <div style={{ fontSize: 10, padding: 10, background: "#eee" }}>
                                            <div className="productlist_th child" style={{ fontSize: 8, fontWeight: 700 }}>
                                                <div style={{ width: 30 }}>순번</div>
                                                <div style={{ width: 40 }}>계약번호</div>
                                                <div style={{ width: 60 }}>계약서작성일</div>
                                                <div style={{ width: 60 }}>잔금일</div>
                                                <div style={{ width: 85 }}>매매/임대인 정보</div>
                                                <div style={{ width: 60 }}>계약서상 수수료</div>
                                                <div style={{ width: 70 }}>실입금 수수료</div>
                                                <div style={{ width: 70 }}>입금일</div>
                                                <div style={{ width: 85 }}>매수/입차인정보</div>
                                                <div style={{ width: 60 }}>계약서상 수수료</div>
                                                <div style={{ width: 70 }}>실입금 수수료</div>
                                                <div style={{ width: 70 }}>입금일</div>
                                            </div>
                                            {Array(3).fill({})?.map((cv, ci) => {
                                                return <div className="productlist_th child" style={{ fontSize: 8 }}>
                                                    <div style={{ width: 30 }}>{ci + 1}</div>
                                                    <div style={{ width: 40 }}>{"00000" + ci}</div>
                                                    <div style={{ width: 60 }}>{moment().format("YYYY.MM.DD")}</div>
                                                    <div style={{ width: 60 }}>{moment().format("YYYY.MM.DD")}</div>
                                                    <div style={{ width: 85 }}>{"홍매매 010-0101-0101"}</div>
                                                    <div style={{ width: 60 }}>{"10,000,000원"}</div>
                                                    <div style={{ width: 70 }}>{"10,000,000원"}</div>
                                                    <div style={{ width: 70 }}>{moment().format("YYYY.MM.DD")}</div>
                                                    <div style={{ width: 85 }}>{"홍매매 010-0101-0101"}</div>
                                                    <div style={{ width: 60 }}>{"10,000,000원"}</div>
                                                    <div style={{ width: 70 }}>{"10,000,000원"}</div>
                                                    <div style={{ width: 70 }}>{moment().format("YYYY.MM.DD")}</div>
                                                </div>
                                            })}
                                        </div>}
                                    </>
                                    );
                                })}
                            </div>
                            <div style={{ display: "flex", gap: 20, alignItems: "center", justifyContent: "end", marginTop: 20 }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "end", gap: 4 }}>
                                    <div style={{ display: "flex", width: 250, alignItems: "center", justifyContent: "space-between" }}>실입금 수수료 총계: <b>50,000,000 원</b></div>
                                    <div style={{ display: "flex", width: 250, alignItems: "center", justifyContent: "space-between" }}>세전 정산 금액 총계: <b>20,000,000 원</b></div>
                                </div>
                                <div style={{ display: "flex", width: 200, flexDirection: "column", alignItems: "end" }}>
                                    <p style={{ fontSize: 16 }}>사무소 총 수익</p>
                                    <p style={{ fontSize: 20 }}><b>30,000,000 원</b></p>
                                </div>
                            </div>

                            <div style={{ display: "flex", gap: 20, alignItems: "start", justifyContent: "center", marginTop: 20 }}>
                                <PriceListBox title={"고정지출"} style={{ width: "33%" }} />
                                <PriceListBox title={"유동지출"} style={{ width: "33%" }} />
                                <PriceListBox title={"기타"} style={{ width: "33%" }} />
                            </div>
                        </div>

                        <div
                            className='margint20'
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'flex-end'
                            }}
                        >
                            <Button
                                buttonTxt={'통계 확인하기'}
                                className={'linenormalbutton'}
                                styles={{
                                    width: 120, height: 40, fontSize: 14
                                }}
                                onPress={() => {

                                }}
                            />
                        </div>
                        <div className='faqlistArea margint20'>

                        </div>
                    </div>
                </div>
            </Layout>

        </>
    )
}

const PriceListBox = (props) => {

    const {
        style = {},
        title = "타이틀",
    } = props;

    const defaultJson = {
        title: "",
        price: 0,
    }

    const [list, setList] = useState([]);

    useEffect(() => {
    }, [])

    return <div style={{
        ...style,
        display: "flex",
        flexDirection: "column",
        gap: 10,
    }}>
        <div style={{
            display: "flex",
            alignItems: "end",
            gap: 10,
        }}>
            <p className='fontsize18 bolds'>{title}</p>
            <p className='fontsize14 bolds'>{numFormat(list?.reduce((sum, data) => {
                return sum + data.price
            }, 0))}원</p>
        </div>

        <div style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            gap: 10,
        }}>
            <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "50%", textAlign: "center" }}>항목</div>
                <div style={{ width: "50%", textAlign: "center" }}>금액</div>
            </div>
            {list?.map((v, i) => {
                return <div style={{ display: "flex", gap: 5 }}>
                    <div style={{ display: "flex", width: "50%", textAlign: "center", gap: 4 }}>
                        <input
                            style={{ width: "100%", height: 24, fontSize: 10 }}
                            placeholder='항목명'
                        />
                        <Button
                            styles={{ flexShrink: 0, width: 40, height: 24, fontSize: 10 }}
                            buttonTxt={'수정'}
                            className={'normalbutton'}
                            onPress={() => { }}
                        />
                    </div>
                    <div style={{ display: "flex", width: "50%", textAlign: "center", gap: 4 }}>
                        <input
                            style={{ width: "100%", height: 24, fontSize: 10 }}
                            value={v.price}
                            onChange={(e) => {
                                let inputValue = e.target.value.replace(/\D/g, "");
                                setList((vL, vi) => {
                                    vL[i].price = Number(inputValue)
                                    return [...vL]
                                })
                            }}
                            placeholder='금액'
                        />
                        <Button
                            styles={{ flexShrink: 0, width: 40, height: 24, fontSize: 10 }}
                            buttonTxt={'수정'}
                            className={'normalbutton'}
                            onPress={() => { }}
                        />
                    </div>
                </div>
            })}
        </div>

        <div>
            <Button
                styles={{ flexShrink: 0, width: 40, height: 24, fontSize: 10 }}
                buttonTxt={'추가'}
                className={'normalbutton'}
                onPress={() => {
                    console.log("추가!");
                    setList(v => {
                        v.push(defaultJson)
                        return [...v]
                    })
                }}
            />
        </div>
    </div>
}